import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {AppTableComponent} from '@shared/components/tables/app-table/app-table.component';
import {AppTableBodyTemplateDirective, AppTableHeaderTemplateDirective} from '@shared/components/tables/app-table/directives/app-table.directives';
import {AppEmptyAlertMessageComponent} from '@shared/components/commons/app-empty-alert-message/app-empty-alert-message.component';
import {AppLoadingOverlayComponent} from '@shared/components/commons/app-loading-overlay/app-loading-overlay.component';
import {AlertService} from '@core/services/alert.service';
import {SelicApiService,} from '@core/services/api/selic-api.service';

@Component({
    selector: 'app-selic-list',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        AppTableComponent,
        AppTableHeaderTemplateDirective,
        AppTableBodyTemplateDirective,
        AppEmptyAlertMessageComponent,
        AppLoadingOverlayComponent
    ],
    templateUrl: './selic-list.component.html',
    styleUrls: ['./selic-list.component.scss']
})
export class SelicListComponent implements OnInit {
    private selicApiService = inject(SelicApiService);
    private alertService = inject(AlertService);

    protected rates: any[] = [];
    protected loading = false;

    ngOnInit(): void {
        this.loadRates();
    }

    private loadRates(): void {
        this.loading = true;
        this.selicApiService.findAll()
            .subscribe({
                next: (response) => {
                    this.rates = response.data || [];
                    this.loading = false;
                },
                error: () => {
                    this.alertService.operationFailure();
                    this.loading = false;
                }
            });
    }

    public syncRates(): void {
        this.loading = true;
        this.selicApiService.sync()
            .subscribe({
                next: (response) => {
                    this.loadRates();
                    this.alertService.successfulOperation();
                    this.loading = false;
                },
                error: () => {
                    this.alertService.operationFailure();
                    this.loading = false;
                }
            });
    }

    protected formatDate(date: string): string {
        if (!date) return '—';
        const d = new Date(date);
        return d.toLocaleDateString('pt-BR', {month: '2-digit', year: 'numeric'});
    }

    protected formatRate(rate: number): string {
        return rate.toFixed(2) + '%';
    }
}

